import { minimalScreenWidth } from '@/common/breakpoints';
import { CTA, styled } from '@volkswagen-onehub/components-core';

export const StyledTextButton = styled(CTA)`
  white-space: nowrap;
  width: fit-content;
`;

export const StyledWebStreamingOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;

  width: 100vw;
  height: 100dvh;

  background-color: black;
  pointer-events: auto;
`;

export const StyledWebStreamingWrapper = styled.div`
  position: absolute;
  inset: 0;

  width: 100%;
  height: 100%;
`;

export const StyledErrorContainer = styled.div`
  position: absolute;
  inset: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: black;
  text-align: center;
  pointer-events: auto;
`;

export const StyledInnerErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.size.dynamic0100};

  padding: ${(props) => props.theme.size.dynamic0150};

  @media screen and ${minimalScreenWidth.m} {
    padding: ${(props) => props.theme.size.dynamic0200};
  }

  @media screen and ${minimalScreenWidth.l} {
    padding: ${(props) => props.theme.size.dynamic0270};
  }

  @media screen and ${minimalScreenWidth.xl} {
    padding: ${(props) => props.theme.size.dynamic0300};
  }
`;

export const StyledErrorButton = styled(CTA)`
  margin: auto;
`;
